import React, {useContext, useMemo} from 'react';
import classNames from 'classnames';
import {LayoutContext} from '../layouts/Default/LayoutContext';

const calcFontSize = (len, isSm) => {
    if (len <= 30) return isSm ? 30 : 38;
    if (len <= 60) return isSm ? 24 : 32;
    if (len <= 100) return isSm ? 20 : 26;
    return isSm ? 15 : 18;
};

const ResponsiveTextLabel = ({
                                 text,
                                 className,
                                 showIcon = true,
                                 style,
                             }) => {
    const {isSm} = useContext(LayoutContext);

    const fontSize = useMemo(
        () => calcFontSize(text?.length ?? 0, isSm),
        [text, isSm]
    );

    const markSize = Math.max(fontSize - 4, 14);

    return (
        <div
            style={{
                minHeight: isSm ? 140 : 180,
                height: '100%',
                width: '100%',
                ...style,
            }}
            className={classNames('flex flex-center text-center p-3', className)}>
            <span style={{fontSize, lineHeight: 1.625, fontWeight: 500}}>
                {showIcon && (
                    <>
                        <svg
                            style={{position: 'absolute', top: 6, left: 8, opacity: 0.08, pointerEvents: 'none'}}
                            width="56" height="42" viewBox="0 0 64 48" fill="none">
                            <path
                                d="M0 48V29.6C0 21.6 1.6 15.2 4.8 10.4C8.13 5.47 13.07 1.87 19.6 0L22.4 5.2C18.27 6.53 15.07 8.87 12.8 12.2C10.53 15.4 9.33 19.2 9.2 23.6H18.4V48H0ZM34 48V29.6C34 21.6 35.6 15.2 38.8 10.4C42.13 5.47 47.07 1.87 53.6 0L56.4 5.2C52.27 6.53 49.07 8.87 46.8 12.2C44.53 15.4 43.33 19.2 43.2 23.6H52.4V48H34Z"
                                fill="currentColor"/>
                        </svg>
                        <svg
                            style={{
                                position: 'absolute',
                                bottom: 10,
                                right: 8,
                                opacity: 0.08,
                                pointerEvents: 'none',
                                transform: 'rotate(180deg)'
                            }}
                            width="56" height="42" viewBox="0 0 64 48" fill="none">
                            <path
                                d="M0 48V29.6C0 21.6 1.6 15.2 4.8 10.4C8.13 5.47 13.07 1.87 19.6 0L22.4 5.2C18.27 6.53 15.07 8.87 12.8 12.2C10.53 15.4 9.33 19.2 9.2 23.6H18.4V48H0ZM34 48V29.6C34 21.6 35.6 15.2 38.8 10.4C42.13 5.47 47.07 1.87 53.6 0L56.4 5.2C52.27 6.53 49.07 8.87 46.8 12.2C44.53 15.4 43.33 19.2 43.2 23.6H52.4V48H34Z"
                                fill="currentColor"/>
                        </svg>
                    </>
                )}
                {text}
            </span>
        </div>
    );
};

export default ResponsiveTextLabel;